module.exports = __webpack_public_path__ + "img/dara-pfp.de7abb9a.jpg";